<template>
  <v-card class="elevation-1 mb-6 rounded-lg mt-0">
    <v-card-title class="pa-7">
      Přiřazení zákazníci
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="orderHeadersByRole"
        :items="customer.items"
        :options.sync="customer.options"
        :server-items-length="customer.serverItemsLength"
        :loading="customer.loading"
        item-key="id"
        class="elevation-0"
      >
        <template v-slot:item.id="{ item }">
          <router-link
            :to="{
              name: 'customers.detail',
              params: {
                customerId: item.id,
              },
            }"
          >
            {{ item.id }}
          </router-link>
        </template>
        <template v-slot:item.phone="{ item }">
          {{ formatPhoneNumber(item.phone) }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { setFilters } from '@/components/mixins/setFilters'
import { formatPhoneNumber } from '@/components/mixins/formatPhoneNumber'

export default {
  name: 'OfferCustomers',
  mixins: [setFilters, formatPhoneNumber],
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      customer: {
        headers: [
          {
            text: 'Id',
            value: 'id',
            roles: ['ROLE_ADMIN'],
            width: '100px',
          },
          {
            text: 'Jméno',
            value: 'name',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Příjmení',
            value: 'surname',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Telefon',
            value: 'phone',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'E-mail',
            value: 'email',
            roles: ['ROLE_ADMIN'],
          },
        ],
        items: [],
        options: {
          page: 1,
          itemsPerPage: 5,
          sortBy: ['id'],
          sortDesc: [true],
        },
        loading: false,
        serverItemsLength: 0,
      },
      customerFooter: {
        totalElements: 0,
        selectedData: {
          params: {},
          items: [],
        },
      },
      cancel: null,
    }
  },
  computed: {
    ...mapState({
      authorities: (state) => state.auth.user.authorities,
    }),
    orderHeadersByRole() {
      return this.customer.headers.filter((e) => e.roles.some((e) => this.authorities.includes(e)))
    },
  },
  watch: {
    status: {
      handler() {
        this.loadCustomers()
      },
    },
    'customer.options': {
      handler() {
        this.loadCustomers()
      },
    },
    '$route.query': {
      handler() {
        this.loadCustomers()
      },
    },
  },
  methods: {
    ...mapActions({
      searchOfferCustomers: 'offer/searchOfferCustomers',
    }),
    loadCustomers() {
      this.customer.loading = true
      const searchParams = {
        options: this.customer.options,
      }
      this.searchOfferCustomers({ id: this.id, params: searchParams })
        .then((response) => {
          this.customerFooter.totalElements = response.data.totalElements
          this.customer.items = response.data.items
          this.customer.serverItemsLength = response.data.totalElements
          this.cancel = null
        })
        .finally(() => {
          this.customer.loading = false
        })
    },
    setFiltersAction(filters) {
      this.customer.options.page = 1
      this.setFilters(filters)
    },
  },
}
</script>
